import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import React from 'react';
import { Badge } from '../../Badge';
import styles from './Tab.Option.scss';
export var TabOption = function TabOption(props) {
  var _classnames;

  var isFirstTab = props.index === 0;
  var isActiveTab = props.activeTabIndex === props.index;
  var isLeftOfActiveTab = props.index === props.activeTabIndex - 1;
  var isRightOfActiveTab = props.index === props.activeTabIndex + 1;
  var isInactiveTab = !isActiveTab && !isLeftOfActiveTab && !isRightOfActiveTab;
  var classes = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(styles.activeTab), isActiveTab), _defineProperty(_classnames, "".concat(styles.inactiveTab), isInactiveTab), _defineProperty(_classnames, "".concat(styles.firstInactiveTab), isFirstTab && !isActiveTab), _defineProperty(_classnames, "".concat(styles.leftOfActive), isLeftOfActiveTab), _defineProperty(_classnames, "".concat(styles.rightOfActive), isRightOfActiveTab), _defineProperty(_classnames, "".concat(styles.grayBackground), isActiveTab && props.activeBackgroundColor === "gray"), _defineProperty(_classnames, "".concat(styles.whiteBackground), isActiveTab && props.activeBackgroundColor === "white"), _classnames));
  return React.createElement("div", {
    role: "presentation"
  }, React.createElement("button", {
    role: "tab",
    type: "button",
    tabIndex: 0,
    title: props.label,
    "data-test": props.dataTest,
    className: classes,
    onClick: function onClick() {
      return props.onTabClicked(props.index);
    }
  }, props.label, Boolean(props.badge) && React.createElement("span", {
    className: styles.badge
  }, React.createElement(Badge, {
    dataTest: "badge-".concat(props.dataTest),
    text: props.badge,
    variant: props.badgeVariant || 'neutral'
  }))));
};
TabOption.defaultProps = {
  activeBackgroundColor: 'gray'
};